<template>
    <div class="form-check">
        <input type="checkbox" class="form-check-input" :id="getId" v-model="currentValue">
        <label class="form-check-label" :for="getId" v-text="getLabel"></label>
    </div>
</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';

    export default {
        mixins: [
            fieldInfo
        ],
        watch: {
            value(newValue, oldValue) {
                this.currentValue = this.value === 'true';
            }
        }
    }
</script>

<style scoped>
    .form-check-label {
        margin-left: 20px;
    }
</style>